<template>
  <v-list-item class="ts-mileage-item"
               :class="[vertical && 'ts-mileage-item--vertical']"
  >
    <v-list-item-avatar>
      <v-img :src="player.meta.image" :alt="player.name"/>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <v-row no-gutters class="align-center">
          <ts-player :player="player"></ts-player>
          <v-spacer></v-spacer>
        </v-row>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-badge :value='player.mileageOriginal' :content="player.mileageOriginal || 0">
        <h1>{{player.mileage}}</h1>
      </v-badge>
      <ts-number-control v-model="player.mileage" @input="changeMileage"></ts-number-control>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import TsPlayer from "./TsPlayer";
import TsNumberControl from "./common/TsNumberControl";
export default {
  name: "TsMileageItem",
  components: {TsNumberControl, TsPlayer},
  props: {
    player: Object,
    vertical: Boolean,
  },
  watch: {
    player() {
      this.player.mileageOriginal = this.player.mileageOriginal || this.player.mileage
    }
  },
  mounted () {
    this.player.mileageOriginal = this.player.mileageOriginal || this.player.mileage
  },
  methods: {
    changeMileage(){
      this.$set(this.player, 'changed', true)
    }
  }
}
</script>

<style lang="scss">
  .ts-mileage-item{
    background: #f3f3f3;

    &--vertical{
      flex-flow:wrap;
      .v-list-item__action{
        flex-basis:100%;
        margin-left:0 !important;
      }
    }

    .v-list-item__action{
      flex-direction: row;
      align-items: center;
    }
  }
</style>
